<template>
  <div>
    <span>{{common.serv.get(code).servName}}</span>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      code: {
        type: [Number, String, Array],
        default: null
      }
    },
    computed: {
      ...mapState(['common'])
    },
    data() {
      return {
        servLable: ''
      }
    },
    mounted() {
      // this.code.split(',').forEach((item, i) => {
      //   this.servLable += (i === 0 ? '' : ',') + this.
      // })
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?0dec13ce